import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { getCookie } from "../../../custom_utils/cookies";
import { PREF_BRANCH_COOKIE, confirmLocation } from "./LocalizationState";
import { convertEmToPx } from "../../../custom_utils/helpers";
export const toggleLocationDropdown = (dropdownOpen)=>{
    const trigger = document.querySelector('#a11y-location-toggler');
    const target = document.querySelector('#a11y-location-dropdown');
    const closeTrigger = document.querySelector('#a11y-location-close');
    if (trigger == null || target == null || closeTrigger == null) {
        return;
    }
    if (dropdownOpen == 'true') {
        trigger.setAttribute('aria-expanded', 'false');
        closeTrigger.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
    } else {
        trigger.setAttribute('aria-expanded', 'true');
        closeTrigger.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
    }
};
export const Localization = {
    LocationDropdown: (props)=>{
        const { selectedLocationId, branchLocations, selectLocation } = props;
        const preferredBranchId = getCookie(PREF_BRANCH_COOKIE);
        const preferredBranch = branchLocations.find((loc)=>loc.id == preferredBranchId);
        const isDesktop = window.innerWidth > convertEmToPx(102.4);
        return /*#__PURE__*/ _jsx("div", {
            className: "lh__dropdown",
            children: /*#__PURE__*/ _jsx("div", {
                className: "lh__formwrap",
                children: isDesktop ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "lh__buttoninput",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                id: "a11y-location-toggler",
                                className: "lh__button",
                                "aria-controls": "a11y-location-dropdown",
                                "aria-expanded": "false",
                                onClick: (e)=>toggleLocationDropdown(e.currentTarget.getAttribute('aria-expanded') == 'true' ? "true" : "false"),
                                children: preferredBranch ? preferredBranch.title : "Selecteren"
                            }),
                            /*#__PURE__*/ _jsx("svg", {
                                className: "lh__icon",
                                "aria-hidden": "true",
                                fill: "none",
                                height: "10",
                                viewBox: "0 0 14 10",
                                width: "14",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ _jsx("path", {
                                    clipRule: "evenodd",
                                    d: "m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z",
                                    fill: "#090b09",
                                    fillRule: "evenodd"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                id: "a11y-location-dropdown",
                                className: "lh__options lho",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "lho__inner",
                                        children: [
                                            preferredBranch && /*#__PURE__*/ _jsxs("div", {
                                                className: "lho__option",
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        checked: selectedLocationId == "0",
                                                        onChange: (e)=>selectLocation(e.target.value),
                                                        type: "radio",
                                                        name: "branch",
                                                        id: "lho_0",
                                                        value: "0",
                                                        onFocus: (e)=>toggleLocationDropdown("false"),
                                                        onBlur: (e)=>document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true")
                                                    }),
                                                    /*#__PURE__*/ _jsx("label", {
                                                        htmlFor: "lho_0",
                                                        children: "Geen voorkeur"
                                                    })
                                                ]
                                            }),
                                            branchLocations.map((loc)=>{
                                                return /*#__PURE__*/ _jsxs("div", {
                                                    className: "lho__option",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("input", {
                                                            checked: selectedLocationId == loc.id,
                                                            onChange: (e)=>selectLocation(e.target.value),
                                                            type: "radio",
                                                            name: "branch",
                                                            id: "lho_" + loc.id,
                                                            value: loc.id,
                                                            onFocus: (e)=>toggleLocationDropdown("false"),
                                                            onBlur: (e)=>document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true")
                                                        }),
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "lho_" + loc.id,
                                                            children: loc.title
                                                        })
                                                    ]
                                                }, loc.id);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "lho__submit",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            id: "a11y-location-close",
                                            className: "lho__button button",
                                            "aria-controls": "a11y-location-dropdown",
                                            "aria-expanded": "false",
                                            disabled: !selectedLocationId,
                                            onClick: (e)=>confirmLocation(selectedLocationId, branchLocations),
                                            onFocus: (e)=>toggleLocationDropdown("false"),
                                            onBlur: (e)=>document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true"),
                                            children: "Selecteer als mijn bieb"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            className: "lh__formlabel",
                            htmlFor: "lh-location",
                            children: "Mijn bieb:"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "lh__forminput",
                            children: [
                                /*#__PURE__*/ _jsxs("select", {
                                    className: "lh__select",
                                    id: "lh-location",
                                    value: preferredBranchId,
                                    onChange: (e)=>confirmLocation(e.target.value, branchLocations),
                                    children: [
                                        /*#__PURE__*/ _jsx("option", {
                                            value: "",
                                            children: preferredBranchId ? "Geen locatie" : "Selecteren"
                                        }),
                                        branchLocations.map((loc)=>{
                                            return /*#__PURE__*/ _jsx("option", {
                                                value: loc.id,
                                                children: loc.title
                                            }, loc.id);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("svg", {
                                    className: "lh__icon",
                                    "aria-hidden": "true",
                                    fill: "none",
                                    height: "10",
                                    viewBox: "0 0 14 10",
                                    width: "14",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ _jsx("path", {
                                        clipRule: "evenodd",
                                        d: "m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z",
                                        fill: "#090b09",
                                        fillRule: "evenodd"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
};
